<template>
  <form>
    <v-container>
      <v-row>
        <v-col cols="12" md="12">
          <v-text-field
            ref="iosPublishKey"
            label="IOS App Publish Key"
            v-model="iosPublishKey"/>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12">
          <v-text-field
            ref="androidPublishKey"
            label="Android App Publish Key"
            v-model="androidPublishKey"/>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12">
          <medium-button
            :loading="saveLoading"
            :onclick="submit"
            :text="$t('appPublishKeySettings.save')"
            :disabled="false"
          ></medium-button>
        </v-col>
      </v-row>
    </v-container>
  </form>
</template>

<script>
import { mapActions } from 'vuex';
import { formValidation } from '../mixins/validation.mixins';

export default {
  mixins: [formValidation],
  props: {
    saveLoading: {
      type: Boolean,
      required: true,
    },
  },
  async mounted() {
    this.appPublishKeySettings = await this.getBookingChannelAppPublishKeySettings({
      bookingChannelId: window.bookingChannelConfig.id,
    });
    this.setPublishKeys();
  },
  data() {
    return {
      appPublishKeySettings: null,
      iosPublishKey: null,
      androidPublishKey: null,
    };
  },
  methods: {
    ...mapActions({
      getBookingChannelAppPublishKeySettings: 'bookingChannel/getBookingChannelAppPublishKeySettings',
    }),
    setPublishKeys() {
      if (this.appPublishKeySettings && this.appPublishKeySettings.appPublishKeys) {
        const iosAppPublishKey = this.appPublishKeySettings.appPublishKeys.find(appPublishKey => appPublishKey.platform === 'ios');
        const androidAppPublishKey = this.appPublishKeySettings.appPublishKeys.find(appPublishKey => appPublishKey.platform === 'android');

        if (iosAppPublishKey) {
          this.iosPublishKey = iosAppPublishKey.publishKey;
        }
        if (androidAppPublishKey) {
          this.androidPublishKey = androidAppPublishKey.publishKey;
        }
      }
    },
    formatAppPublishKeysPayload() {
      return [
        this.iosPublishKey && {
          platform: 'ios',
          publishKey: this.iosPublishKey,
        },
        this.androidPublishKey && {
          platform: 'android',
          publishKey: this.androidPublishKey,
        },
      ].filter(Boolean);
    },
    async submit() {
      this.$emit('submit', {
        appPublishKeys: this.formatAppPublishKeysPayload(),
      });
    },
  },
};
</script>

<style scope>

</style>
